import { DialogUnwrapped as BubbleUIDialogUnwrapped } from '@klarna/bubble-ui'
import React from 'react'

function DialogUnwrapped(props) {
  return <BubbleUIDialogUnwrapped {...props} useWindowHeight={process.env.NODE_ENV !== 'test'} />
}

export default DialogUnwrapped
